var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", staticStyle: { display: "none" } },
    [
      _c("label", { attrs: { for: "faxonly" } }, [
        _vm._v("Fax Only\n        "),
        _c("input", {
          attrs: {
            type: "checkbox",
            autocomplete: "off",
            tabindex: "-1",
            name: _vm.parameter,
            id: _vm.parameter,
            checked: "checked",
            required: "",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }